import { PricingBrandWarrantyRelationship } from './account-admin-company.model';
import { Address, AuthorizedBrand, CompanyCategory, CompanyContact, CompanyServices, CompanyType, ParentCompany } from './account-admin-search';

export interface companyResultData {
    active: boolean;
    commercialF1: boolean;
    createdBy: string;
    creationDate: string;
    dbId: number;
    legalEntityF1: boolean;
    mobileNumber: string;
    residentialF1: boolean;
    id: string;
    hvacCompanyId: string;
    parentCompany: ParentCompany;
    soldToCustomerId: string;
    shipToCustomerId: string;
    payerCustomerId: string;
    companyType?: CompanyType;
    companyCategory: CompanyCategory;
    name: string;
    emailAddress: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    phoneNumber: string | null;
    faxNumber: number | null;
    notes: string;
    brands: (AuthorizedBrand)[];
    companyServices: CompanyServices[];
    brandFamily: string;
    tollFreeNumber: number | null;
    url: string;
    searchRadius: string;
    contractorLicense: string;
    divRegNum: string;
    language: string[];
    mobileNum: number | null;
    operatingTime: string;
    warrantyType: string;
    c10Parent: string;
    c10Child: string;
    storeNumber: string;
    flagForPOS: boolean;
    flagForDC: boolean;
    companyContacts: CompanyContact[];
    ownershipType: string;
    isActive: boolean;
    legalEntity: boolean;
    isPrimaryAccount: boolean;
    priceListType?: string;
    includeInDistributorLocator?: boolean;
    priceGroup?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    dealerLocatorBrands?: string;
    brandedRelationships?: PricingBrandWarrantyRelationship[];
    pricingWarrantyRelationships?: PricingBrandWarrantyRelationship[];
    latitude?: string;
    longitude?: string;
    locatorName?: string;
    salesOfficeNumber?: string;
    inventoryAPI?: string;
    regionCode?: string;
    customerUserName?: string;
    customerGUID?: string;
    address: Address;
}

export interface companySearchResult {
    data: companyResultData[];
    totalCount: number;
}

export interface CompanyResultDataResponse {
    hvacCompanyId: number;
    soldTo: string;
    shipTo: string;
    payer: string;
    companyName: string;
    state: string;
    city: string;
    phone: string;
    email: string;
    address1: string;
    address2: string;
    brandsName: string;
    companyType: string;
    country: string;
    fax: string;
    parentBrandsName: string;
    postalCode: string;
    warranty: string;
    companyCategory?: string;
    companyServices?: string[];
    authorizedBrands?: AuthorizedBrand[];
}

export interface CompanySearchResultResponse {
    data: CompanyResultDataResponse[];
    totalCount: number;
}

export interface AccountAdminDistributorBranch {
    companyName: string;
    hvacCompanyId: string;
}

export interface LegalEntityResponse {
    companyName: string;
    hvacCompanyId: string;
}
